module.exports = __webpack_public_path__ + "media/images/age-37939c2b76376b86477c9f138358ee32.png";